/**
 *  <Desription of Service here>
 *
 * @export
 * @class ColorManager
 */
export class ColorManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'DataManager'];
  public colors: any;
  public currentColor: any;
  public currentColorSet: any;
  public selectedColorSet: any;
  public standard: any;
  public mobile: any;

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any, public DataManager: any) {
    this.$log = $log.getInstance('ColorManager', false);
    this.$log.debug('constructor');
  }

  public init(config) {
    this.$log.debug('init')
    this.mobile = config.settings.colorPicker.mobile;
    this.standard = config.settings.colorPicker.standard;

    // Custom colorpicker
    this.colors = this.DataManager.config.colors
    // initial value for colorset
    this.selectedColorSet = 'red';
    this.currentColorSet = this.colors.variantColors[this.selectedColorSet];
  }

  public setColor(color) {
    this.$log.debug('setColor', color)
    this.currentColor = color;
  }

  public getColor() {
    this.$log.debug('getColor')
    return this.currentColor;
  }

  public selectColorSet(colorSet) {
    this.$log.debug('selectColorSet', colorSet)

    this.selectedColorSet = colorSet
    this.currentColorSet = this.colors.variantColors[colorSet];
    if (this.currentColorSet != undefined) {
       if (this.currentColorSet.length >= 4) {
         this.setColor(this.currentColorSet[4]);
       } else {
         this.setColor(this.currentColorSet[0]);
       }
    }
  }

  public resetColors() {
    this.$log.debug('resetColors')
    this.selectedColorSet = 'red';
    this.currentColorSet = this.colors.variantColors[this.selectedColorSet];
    this.setColor(this.currentColorSet[4]);
  }

};



/** WEBPACK FOOTER **
 ** ./src/common/services/color-manager/color-manager.ts
 **/